// extracted by mini-css-extract-plugin
module.exports = {"menu-color":"#666","menu-color-active":"#05C8AF","menu-background":"#fff"};